// @ts-ignore
import formatMoney from 'accounting-js/lib/formatMoney';

export default function (value: any){
    return formatMoney(value, {symbol: '$ '});
}